/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";
import ValidateItem from "../../../helpers/validation/validateInput";
import RangeSlider from "../../ui/RangeSlider";
import { SketchPicker } from "react-color";
import { Checkboard } from "react-color/lib/components/common";

class ShadowInput extends Component {
	constructor(props) {
		super(props);

		this.state = {
			minimizePlaceholder: false,
			value: props.fieldState.initialValue,
			showPicker: false,
			showColorPicker: false,
			rgba: {
				r: 41,
				g: 47,
				b: 193,
				a: 1,
			},
			mode: "dark",
		};
	}

	validate = value => {
		const { placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage } = this.props;
		return ValidateItem(value, placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage);
	};

	updateValue = newValue => {
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	togglePicker = () => {
		this.setState({ showPicker: !this.state.showPicker });
	};

	toggleColorPicker = () => {
		this.setState({ showColorPicker: !this.state.showColorPicker });
	};

	changeRadius = value => {
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: {
					radius: "0",
					offset: { width: "0", height: "0" },
					opacity: this.props.type === "text" ? null : "0",
					color: "rgba(41,47,193,1)",
			  };
		newValue.radius = value;
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	changeOpacity = value => {
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: {
					radius: "0",
					offset: { width: "0", height: "0" },
					opacity: this.props.type === "text" ? null : "0",
					color: "rgba(41,47,193,1)",
			  };
		newValue.opacity = String(value / 100);
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	changeOffsetX = value => {
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: {
					radius: "0",
					offset: { width: "0", height: "0" },
					opacity: this.props.type === "text" ? null : "0",
					color: "rgba(41,47,193,1)",
			  };
		newValue.offset.width = value;
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	changeOffsetY = value => {
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: {
					radius: "0",
					offset: { width: "0", height: "0" },
					opacity: this.props.type === "text" ? null : "0",
					color: "rgba(41,47,193,1)",
			  };
		newValue.offset.height = value;
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	changeColor = color => {
		let { r, g, b, a } = color.rgb;
		this.setState({ rgba: color.rgb });
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: {
					radius: "0",
					offset: { width: "0", height: "0" },
					opacity: this.props.type === "text" ? null : "0",
					color: "rgba(41,47,193,1)",
			  };
		newValue.color = `rgba(${r},${g},${b},${a})`;
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	removeShadow = () => {
		this.props.fieldApi.setValue(null);
		this.props.fieldApi.setTouched(true);
		this.togglePicker();
	};

	toggleMode = () => {
		this.setState({ mode: this.state.mode === "dark" ? "light" : "dark" });
	};

	render() {
		const { fieldState, placeholder, type, showPreview, isRequired } = this.props;
		const { value, error } = fieldState;
		const { rgba } = this.state;
		const shouldFocus = value && value !== null;
		const isFocused = shouldFocus ? " focus" : "";
		const hasError = error ? " has-error" : "";
		let shadowPreview = "";

		if (value) {
			if (type === "text") {
				shadowPreview = `${value.offset.width}px ${value.offset.height}px ${value.radius}px rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
			} else {
				shadowPreview = `${value.offset.width}px ${value.offset.height}px ${value.radius}px rgba(${rgba.r}, ${
					rgba.g
				}, ${rgba.b}, ${parseFloat(rgba.a) * parseFloat(value.opacity)})`;
			}
		}

		return (
			<div className="color-picker-input">
				<div className={`input-wrap${isFocused}${hasError}`}>
					<div className="placeholder">
						<span className={shouldFocus ? "caption-text" : ""}>
							{isRequired && <span className="isrequired-label">*</span>}
							{placeholder}
						</span>
					</div>
					<input className="dummy-input" onFocus={() => this.togglePicker()} />
					<div className="color-picker-value" onClick={() => this.togglePicker()}>
						<div style={{ boxShadow: shadowPreview }}></div>
					</div>
					<div
						className={`coverall ${this.state.showPicker ? "on" : ""}`}
						onClick={() => this.togglePicker()}
					></div>
					<div className={`input-modal ${this.state.showPicker ? "on" : "off"}`}>
						{showPreview && (
							<div className={`shadow-preview ${this.state.mode}`}>
								<div
									className={`${this.state.mode} btn-circle`}
									title={this.state.mode === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
									onClick={this.toggleMode}
								>
									<i className={`fal ${this.state.mode === "dark" ? "fa-moon" : "fa-sun"}`}></i>
								</div>
								{type === "text" ? (
									<div className="shadow-preview-text title" style={{ textShadow: shadowPreview }}>
										SHADOW
									</div>
								) : (
									<div className="shadow-preview-box" style={{ boxShadow: shadowPreview }}></div>
								)}
							</div>
						)}
						<input className="dummy-input" onFocus={() => this.toggleColorPicker()} />
						<div className="color-picker-value" onClick={() => this.toggleColorPicker()}>
							<div className="color-preview">
								<div
									className="color-preview-value"
									style={{ backgroundColor: value ? value.color : null }}
								></div>
								<Checkboard size={12} white="#ffffff" grey="#cccccc" />
							</div>
						</div>
						<div
							className={`coverall ${this.state.showColorPicker ? "on" : ""}`}
							onClick={() => this.toggleColorPicker()}
						></div>
						<div className={`input-modal ${this.state.showColorPicker ? "on" : "off"}`}>
							<SketchPicker color={rgba} presetColors={[]} onChangeComplete={this.changeColor} />
						</div>
						<RangeSlider
							onChange={this.changeRadius}
							value={value ? value.radius : 0}
							min={0}
							max={100}
							placeholder="Radius"
						/>
						{type !== "text" && (
							<RangeSlider
								onChange={this.changeOpacity}
								value={value ? Math.round(value.opacity * 100) : 0}
								min={0}
								max={100}
								placeholder="Opacity"
							/>
						)}
						<RangeSlider
							onChange={this.changeOffsetX}
							value={value ? value.offset.width : 0}
							min={-100}
							max={100}
							placeholder="Horizontal Offset"
						/>
						<RangeSlider
							onChange={this.changeOffsetY}
							value={value ? value.offset.height : 0}
							min={-100}
							max={100}
							placeholder="Vertical Offset"
						/>
						<div className="btn btn-primary wide m-top" onClick={this.removeShadow}>
							Clear Shadow
						</div>
					</div>
				</div>
			</div>
		);
	}
}

ShadowInput.propTypes = {
	field: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	autocomplete: PropTypes.string,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	type: PropTypes.string,
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	showPreview: PropTypes.bool,
};

const Wrapper = asField(({ fieldState, ...props }) => <ShadowInput fieldState={fieldState} {...props} />);

export default Wrapper;
